module.exports = __webpack_public_path__ + "static/media/state-bank-of-india.34094c73.svg";